import { getDisplayName } from '@/lib/displayName';
import SwygWaveMark from '@/components/SwygWaveMark';

type BrandHeaderProps = {
  title: string;
  user?: Parameters<typeof getDisplayName>[0];
  /** Optional override when nickname already resolved */
  nickname?: string;
  titleClassName?: string;
  brandClassName?: string;
};

/** Sauce-sized title — keep Mainstage / Pulse / Profile / Sauce identical. */
export const BRAND_HEADER_TITLE_CLASS =
  'text-2xl font-bold text-deep-800 tracking-tight shrink-0';
export const BRAND_HEADER_BRAND_CLASS =
  'text-sm font-semibold text-deep-800 min-w-0 truncate text-right';

/**
 * Shared tab header: page title + SWYG X {avatarName}.
 */
export default function BrandHeader({
  title,
  user,
  nickname,
  titleClassName = BRAND_HEADER_TITLE_CLASS,
  brandClassName = BRAND_HEADER_BRAND_CLASS,
}: BrandHeaderProps) {
  const name = nickname || getDisplayName(user);

  return (
    <div className="flex items-center justify-between gap-3">
      <h1 className={titleClassName}>{title}</h1>
      <p className={`${brandClassName} flex items-center justify-end gap-1.5`}>
        <SwygWaveMark size="sm" className="shrink-0" />
        <span className="font-normal">X</span>
        <span className="font-semibold truncate">{name}</span>
      </p>
    </div>
  );
}
